import { gql } from '@ppl/utils/graphql.utils';


export const gqlSendVerificationLinkToEmail = gql`
  mutation sendVerificationLinkToEmail($input: SendVerificationLinkToEmailInput!) {
    sendVerificationLinkToEmail(input: $input) {
      sent
    }
  }
`;
